import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import '../../style/dashboard.css';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const BoothPramukhSurveyDashboard = () => {
    const navigate = useNavigate();

    // Get App ID, Total Voters, and Language from context
    const { appId, total_voters, language } = useAppId();

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            title: "Booth Pramukh Survey Dashboard",
            totalVoters: "Total Voters",
            totalSurvey: "Total Survey",
            surveyed: "Answered",
            notAvailable: "Not Available :",
            positive: "Positive",
            negative: "Negative",
            doubtful: "Doubtful",
            cantSay: "Can't Say",
            surveyReports: "SURVEY REPORTS",
            mySurvey: "My Survey",
            boothWiseSurvey: "My Voter",
            partyCadreSurvey: "Party Cadre Survey",
            personalCadreSurvey: "Candidate Cadre Survey",
            callCenterSurveyOption: "Call Center Survey",
            deathSurvey: "Death Survey",
            shiftSurvey: "Shift Survey",
            wrongNumberVoter: "Wrong Number Voter",
            callNotReceivedVoter: "Call Not Received Voter",
            surveySection: "SURVEY"
        },
        hi: {
            title: "बूथ प्रमुख सर्वे डैशबोर्ड",
            totalVoters: "कुल मतदाता",
            totalSurvey: "कुल सर्वे",
            surveyed: "उत्तर दिया",
            notAvailable: "अनुपलब्ध :",
            positive: "सकारात्मक",
            negative: "नकारात्मक",
            doubtful: "संदिग्ध",
            cantSay: "कह नहीं सकते",
            surveyReports: "सर्वे रिपोर्ट",
            mySurvey: "मेरा सर्वे",
            boothWiseSurvey: "मेरा मतदाता",
            partyCadreSurvey: "पार्टी कार्यकर्ता सर्वे",
            personalCadreSurvey: "उम्मीदवार कार्यकर्ता सर्वे",
            callCenterSurveyOption: "कॉल सेंटर सर्वे",
            deathSurvey: "मृत्यु सर्वे",
            shiftSurvey: "स्थानांतरण सर्वे",
            wrongNumberVoter: "गलत नंबर मतदाता",
            callNotReceivedVoter: "कॉल न प्राप्त मतदाता",
            surveySection: "सर्वे"

        },
        gu: {
            title: "બૂથ પ્રમુખ સર્વે ડેશબોર્ડ",
            totalVoters: "કુલ મતદારો",
            totalSurvey: "કુલ સર્વે",
            surveyed: "જવાબ આપેલ",
            notAvailable: "ઉપલબ્ધ નથી :",
            positive: "હકારાત્મક",
            negative: "નકારાત્મક",
            doubtful: "શંકાસ્પદ",
            cantSay: "કહી શકાય નહીં",
            surveyReports: "સર્વે રિપોર્ટ્સ",
            mySurvey: "મારો સર્વે",
            boothWiseSurvey: "મારા મતદાર",
            partyCadreSurvey: "પાર્ટી કાર્યકર્તા સર્વે",
            personalCadreSurvey: "ઉમેદવાર કાર્યકર્તા સર્વે",
            callCenterSurveyOption: "કોલ સેન્ટર સર્વે",
            deathSurvey: "મૃત્યુ સર્વે",
            shiftSurvey: "શિફ્ટ સર્વે",
            wrongNumberVoter: "ખોટા નંબર મતદાર",
            callNotReceivedVoter: "કોલ ન મળેલ મતદાર",
            surveySection: "સર્વે"
        }
    };

    const txt = t[lang];



    // --- Professional Icons ---
    const IconWrapper = ({ children, bgColor, color }) => (
        <div style={{
            width: '46px',
            height: '46px',
            borderRadius: '12px',
            backgroundColor: bgColor,
            color: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '12px'
        }}>
            {children}
        </div>
    );




    const PartyCadreIcon = () => <IconWrapper bgColor="#fff7ed" color="#ea580c"><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" /><path d="M12 13c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" /></svg></IconWrapper>;
    const PersonalCadreIcon = () => <IconWrapper bgColor="#eff6ff" color="#2563eb"><svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z" /></svg></IconWrapper>;
    const CallCenterIcon = () => <IconWrapper bgColor="#f0fdf4" color="#16a34a"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" /></svg></IconWrapper>;
    const BoothIcon = () => <IconWrapper bgColor="#fee2e2" color="#dc2626"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" /></svg></IconWrapper>;
    const DeathIcon = () => <IconWrapper bgColor="#f1f5f9" color="#475569"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><line x1="4.93" y1="4.93" x2="19.07" y2="19.07" /></svg></IconWrapper>;
    const ShiftIcon = () => <IconWrapper bgColor="#fff7ed" color="#d97706"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 110-5 2.5 2.5 0 010 5z" /></svg></IconWrapper>;
    const WrongNumIcon = () => <IconWrapper bgColor="#fdf2f8" color="#e11d48"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M10.5 10.5l3 3m0-3l-3 3M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z" /></svg></IconWrapper>;
    const CallMissedIcon = () => <IconWrapper bgColor="#f8fafc" color="#334155"><svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24"><path d="M16 2v4m-2-2h4M3.5 10A18.5 18.5 0 0021 21M3.5 10c0-3.5 2.5-6 6-6s6 2.5 6 6M3.5 10v4c0 3.5 2.5 6 6 6s6-2.5 6-6v-4" /></svg></IconWrapper>;


    // Initial State for Survey Data
    const [data, setData] = useState({
        totalVoters: 0,
        totalSurvey: 0,
        notAvailable: 0,
        totalAnswered: 0,
        pieData: [
            { name: txt.positive, value: 0, color: '#10b981' }, // Green
            { name: txt.negative, value: 0, color: '#ef4444' }, // Red
            { name: txt.doubtful, value: 0, color: '#f59e0b' }, // Orange/Yellow
            { name: txt.cantSay, value: 0, color: '#64748b' },  // Slate/Gray
        ],
    });

    // Update pieData labels when language changes
    useEffect(() => {
        setData(prev => ({
            ...prev,
            pieData: [
                { name: txt.positive, value: prev.pieData[0]?.value || 0, color: '#10b981' },
                { name: txt.negative, value: prev.pieData[1]?.value || 0, color: '#ef4444' },
                { name: txt.doubtful, value: prev.pieData[2]?.value || 0, color: '#f59e0b' },
                { name: txt.cantSay, value: prev.pieData[3]?.value || 0, color: '#64748b' },
            ]
        }));
    }, [lang, txt.positive, txt.negative, txt.doubtful, txt.cantSay]);

    // Fallbacks to LocalStorage if context drops
    const currentAppId = appId || localStorage.getItem('appId') || "";
    const currentBoothNo = localStorage.getItem('boothNo') || "";
    const currentTotalVoters = total_voters || localStorage.getItem('totalVoters') || 0;

    useEffect(() => {
        if (currentAppId && currentBoothNo) {
            fetchData();
        }
    }, [currentAppId, currentBoothNo]);

    const fetchData = async () => {
        try {
            // Guarantee variables are sent exactly as requested
            const payload = {
                app_id: String(currentAppId),
                booth_no: String(currentBoothNo)
            };

            const response = await axios.post(`${BASE_URL}/api/dis_boothpramukh_survey_dashboard`, payload);

            if (response.data.success && response.data.data && response.data.data.Success === "1") {
                const result = (response.data.data.result && response.data.data.result.length > 0) ? response.data.data.result[0] : {};
                const result2 = (response.data.data.result2 && response.data.data.result2.length > 0) ? response.data.data.result2[0] : {};

                // Extract overview counts
                const apiTotalSurvey = Number(result.total_survey) || 0;
                const apiNotAvailable = Number(result.not_available) || 0;

                // Extract breakdown counts (p, n, d, c)
                const positiveCount = Number(result2.p) || 0;
                const negativeCount = Number(result2.n) || 0;
                const doubtfulCount = Number(result2.d) || 0;
                const cantSayCount = Number(result2.c) || 0;

                // Calculate Totals for Pie Chart Center
                const totalAnswered = positiveCount + negativeCount + doubtfulCount + cantSayCount;

                // Get context voters or fallback
                const apiTotalVoters = Number(currentTotalVoters);

                setData({
                    totalVoters: apiTotalVoters > 0 ? apiTotalVoters : apiTotalSurvey, // Fallback if no total voters
                    totalSurvey: apiTotalSurvey,
                    notAvailable: apiNotAvailable,
                    totalAnswered: totalAnswered,
                    pieData: [
                        { name: txt.positive, value: positiveCount, color: '#10b981' },
                        { name: txt.negative, value: negativeCount, color: '#ef4444' },
                        { name: txt.doubtful, value: doubtfulCount, color: '#f59e0b' },
                        { name: txt.cantSay, value: cantSayCount, color: '#64748b' },
                    ]
                });
            }
        } catch (error) {
            console.error("Error fetching survey dashboard data:", error);
        }
    };

    // --- Updated navigate handler to accept state ---
    const handleNavigate = (path, stateObj = null) => {
        if (stateObj) {
            navigate(path, { state: stateObj });
        } else {
            navigate(path);
        }
    };

    const primarySurveyOptions = [
        { title: txt.partyCadreSurvey, icon: <PartyCadreIcon />, onClick: () => { handleNavigate('/dis_party_cadre_survey_dash') } },
        { title: txt.personalCadreSurvey, icon: <PersonalCadreIcon />, onClick: () => { handleNavigate('/dis_personal_cadre_survey_dash') } },
        { title: txt.callCenterSurveyOption, icon: <CallCenterIcon />, onClick: () => { handleNavigate('/dis_call_center_survey_dash') } },
    ];
    // --- SURVEY OPTIONS LIST (UPDATED with route state) ---
    const surveyOptions = [
        // { 
        //     title: txt.mySurvey, 
        //     icon: '📋', 
        //     onClick: () => handleNavigate('/dis_user_wise_survey_voter', { 
        //         user_id: localStorage.getItem('userId') || '', 
        //         user_type: localStorage.getItem('userType') || '' 
        //     }) 
        // },
        {
            title: txt.boothWiseSurvey,
            icon: '🏪',
            onClick: () => handleNavigate('/dis_booth_wise_survey_voter', {
                booth_no: localStorage.getItem('boothNo') || ''
            })
        },
        { title: txt.deathSurvey, icon: <DeathIcon />, onClick: () => { handleNavigate('/dis_death_voter') } },
        { title: txt.shiftSurvey, icon: <ShiftIcon />, onClick: () => { handleNavigate('/dis_shifted_out_voter') } },
        { title: txt.wrongNumberVoter, icon: <WrongNumIcon />, onClick: () => { handleNavigate('/dis_wrong_mobile_no_voter') } },
        { title: txt.callNotReceivedVoter, icon: <CallMissedIcon />, onClick: () => { handleNavigate('/dis_call_not_received_voter') } },
    ];

    // Custom Label Render for Donut Chart
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
        if (!percent || percent === 0) return null;
        const RADIAN = Math.PI / 180;
        const radius = outerRadius + 20;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="#334155" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize="12" fontWeight="600">
                {`${(percent * 100).toFixed(1)}%`}
            </text>
        );
    };

    return (
        <div className="app-container dashboard-page">
            <div className="dashboard-content container-fluid p-4">

                <Header title={txt.title} />

                <div className="row g-4 mb-5 fade-in-up mt-1" style={{ animationDelay: '0.2s' }}>

                    {/* --- Left Side: Stats and Chart --- */}
                    <div className="col-lg-5 col-md-12">
                        <div className="survey-card h-90 d-flex flex-column justify-content-between">
                            <div className="top-stats-row">
                                <div className="stat-box">
                                    <span className="stat-label">{txt.totalVoters}</span>
                                    <span className="stat-value text-dark">{data.totalVoters.toLocaleString()}</span>
                                </div>
                                <div className="stat-divider"></div>
                                <div className="stat-box">
                                    <span className="stat-label">{txt.totalSurvey}</span>
                                    <span className="stat-value text-primary">{data.totalSurvey.toLocaleString()}</span>
                                </div>
                            </div>

                            {/* Chart Area */}
                            <div className="chart-wrapper">
                                {data.totalAnswered === 0 ? (
                                    /* Show empty gray donut if nothing is answered yet to prevent Recharts from looking broken */
                                    <div style={{ height: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <div style={{ width: '220px', height: '220px', borderRadius: '50%', border: '25px solid #f1f5f9' }}></div>
                                    </div>
                                ) : (
                                    <ResponsiveContainer width="100%" height={280}>
                                        <PieChart>
                                            <Pie
                                                data={data.pieData}
                                                cx="50%"
                                                cy="50%"
                                                innerRadius={80}
                                                outerRadius={110}
                                                paddingAngle={0}
                                                dataKey="value"
                                                startAngle={90}
                                                endAngle={-270}
                                                label={renderCustomizedLabel}
                                                labelLine={true}
                                            >
                                                {data.pieData.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
                                                ))}
                                            </Pie>
                                            <Tooltip
                                                formatter={(value) => value.toLocaleString()}
                                                contentStyle={{ borderRadius: '8px', border: 'none', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                                            />
                                        </PieChart>
                                    </ResponsiveContainer>
                                )}

                                {/* Center Text */}
                                <div className="chart-center-text">
                                    <span className="survey-percentage" style={{ fontSize: '24px' }}>
                                        {data.totalAnswered.toLocaleString()}
                                    </span>
                                    <span className="survey-label">{txt.surveyed}</span>
                                </div>
                            </div>

                            {/* Pending/Remaining Alert (For Not Available) */}
                            <div className="unavailable-pill" style={{ backgroundColor: '#fef2f2', color: '#991b1b', borderColor: '#fecaca' }}>
                                {txt.notAvailable} <strong style={{ color: '#ef4444', fontSize: '16px' }}>{data.notAvailable.toLocaleString()}</strong>
                            </div>

                            {/* Bottom Stats Grid */}
                            <div className="bottom-stats-grid">
                                {data.pieData.map((entry, index) => (
                                    <div key={index} className={`bottom-stat-item ${index !== data.pieData.length - 1 ? 'border-right' : ''}`}>
                                        <span className="b-stat-value" style={{ color: entry.color }}>
                                            {entry.value.toLocaleString()}
                                        </span>
                                        <span className="b-stat-label">{entry.name}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* --- Right Side: Overall Survey Options --- */}
                    <div className="col-lg-7 col-md-12">
                       
                        <div className="survey-card">
                            <div className="pb-4">
                                <h4 className="section-title">{txt.surveyReports}</h4>
                            </div>


                            <div className="row g-3">
                                {surveyOptions.map((option, index) => (
                                    <div key={index} className="col-6 col-md-4">
                                        <div className="option-card" onClick={option.onClick}>
                                            <div className="option-icon">{option.icon}</div>
                                            <span className="option-text">{option.title}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .survey-card {
                    background: white;
                    border-radius: 16px;
                    padding: 24px;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.03);
                    border: 1px solid #f1f5f9;
                }
                .top-stats-row {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 20px;
                }
                .stat-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    min-width: 120px;
                }
                .stat-label {
                    font-size: 13px;
                    color: #64748b;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                .stat-value {
                    font-size: 20px;
                    font-weight: 800;
                }
                .stat-divider {
                    width: 1px;
                    height: 40px;
                    background-color: #e2e8f0;
                    margin: 0 20px;
                }
                .chart-wrapper {
                    position: relative;
                    margin: 10px 0 25px 0;
                }
                .chart-center-text {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    pointer-events: none;
                }
                .survey-percentage {
                    font-size: 22px;
                    font-weight: 800;
                    color: #0f172a;
                }
                .survey-label {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 600;
                    margin-top: 4px;
                }
                .unavailable-pill {
                    font-weight: 500;
                    font-size: 14px;
                    text-align: center;
                    padding: 8px;
                    border-radius: 6px;
                    margin-bottom: 20px;
                    border: 1px solid;
                }
                .bottom-stats-grid {
                    display: flex;
                    justify-content: space-between;
                    border-top: 1px solid #f1f5f9;
                    padding-top: 15px;
                }
                .bottom-stat-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                }
                .border-right {
                    border-right: 1px solid #e2e8f0;
                }
                .b-stat-value {
                    font-size: 18px;
                    font-weight: 800;
                    margin-bottom: 2px;
                }
                .b-stat-label {
                    font-size: 11px;
                    color: #64748b;
                    font-weight: 600;
                }
                .section-title {
                    font-size: 14px;
                    font-weight: 700;
                    color: #475569;
                    letter-spacing: 0.5px;
                    text-transform: uppercase;
                    margin: 0;
                }
                .option-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 25px 15px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    height: 100%;
                }
                .option-card:hover {
                    border-color: #3b82f6;
                    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
                    transform: translateY(-2px);
                }
                .option-icon {
                    font-size: 28px;
                    margin-bottom: 12px;
                }
                .option-text {
                    font-size: 13px;
                    font-weight: 600;
                    color: #1e293b;
                    text-align: center;
                    line-height: 1.4;
                }
            `}</style>
        </div>
    );
};

export default BoothPramukhSurveyDashboard;